import { createSignal, onCleanup } from 'solid-js'

/**
 * Tracks an element's rendered width so an SVG chart can lay itself out in
 * CSS pixels (keeping text at a fixed size) instead of scaling a viewBox.
 *
 * @param fallback - Width to assume before the element is measured.
 * @returns A `ref` to attach to the element and the reactive `width`.
 */
export function createContainerWidth(fallback = 640) {
   const [width, setWidth] = createSignal(fallback)

   /**
    * Ref callback that starts observing the element.
    *
    * @param element - The element whose width to track.
    */
   const ref = (element: HTMLElement) => {
      if (typeof ResizeObserver === 'undefined') {
         return
      }
      const observer = new ResizeObserver(entries => {
         const measured = entries[0]?.contentRect.width
         if (measured && measured > 0) {
            setWidth(measured)
         }
      })
      observer.observe(element)
      onCleanup(() => observer.disconnect())
   }

   return { ref, width }
}
